import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=8f5126b2&scoped=true&"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=8f5126b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5126b2",
  null
  
)

export default component.exports